export default __webpack_public_path__ + "static/media/sanctuary-subdued.3bbe800c.png";